import axios from 'axios';
import { auth } from '../../../firebase';

const apiUrl = process.env['NX_API_URL'];

export type fetchCashManagementArgs = {
  accountId?: string;
  info?: string;
  dates?: Date[];
  companyID?: string;
};

export const fetchCashManagement = async (
  { accountId, info, dates, companyID }: fetchCashManagementArgs,
  signal?: AbortSignal
) => {
  let dateStart = null;
  let dateEnd = null;
  if (dates) {
    dateEnd = dates[1] || dates[0];
    dateStart = dates[0];
  }

  const response = await axios.get(`${apiUrl}/api/cashManagement`, {
    signal,
    params: {
      accountId: accountId,
      info: info ?? null,
      dateStart: dateStart,
      dateEnd: dateEnd,
      companyID,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  return response.data;
};

export const fetchCashManagementHistorcalData = async (
  { accountId, info, dates, companyID }: fetchCashManagementArgs,
  signal?: AbortSignal
) => {
  let dateStart = null;
  let dateEnd = null;
  if (dates) {
    dateEnd = dates[1] || dates[0];
    dateStart = dates[0];
  }

  const response = await axios.get(
    `${apiUrl}/api/cashManagement/transactions`,
    {
      signal,
      params: {
        accountId: accountId,
        info: info ?? null,
        dateStart: dateStart,
        dateEnd: dateEnd,
        companyID,
        clientDate: new Date(),
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );
  return response.data;
};

export const fetchCashManagementAccounts = async (
  companyID: string,
  signal?: AbortSignal
) => {
  const response = await axios.get(`${apiUrl}/api/cashManagement/accounts`, {
    signal,
    params: { companyID },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  return response.data;
};

export const fetchCashManagementAccountsResume = async (
  companyID: string,
  signal?: AbortSignal
) => {
  const response = await axios.get(
    `${apiUrl}/api/cashManagement/accountsResume`,
    {
      signal,
      params: {
        companyID,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );
  return response.data;
};
